import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { KEY_WORD_AUTHENTICATED_USER } from '@core/constants';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class TabSyncService {
  constructor(private authService: AuthService) {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(takeUntilDestroyed())
      .subscribe((event) => {
        if (event.key === KEY_WORD_AUTHENTICATED_USER) {
          this.handleAuthChange(event);
        }
      });
  }

  private handleAuthChange(event: StorageEvent): void {
    const currentUser = this.authService.authenticatedUser();

    if (!event.newValue && currentUser) {
      this.authService.logout();
    }

    if (event.newValue && !currentUser) {
      window.location.reload();
    }
  }
}
